import type { UUID } from '@/utils/uuid';

export const teamQueryKeys = {
  lists: () => ['teams'] as const,
  list: (tenantId?: UUID, limit?: number, filter?: string) =>
    ['teams', tenantId, limit ?? null, filter ?? null] as const,
  listByTenant: (tenantId?: UUID) => ['teams', tenantId] as const,
  detail: (tenantId?: UUID, teamId?: UUID) =>
    ['team', tenantId, teamId] as const,
  memberList: (
    tenantId?: UUID,
    teamId?: UUID,
    limit?: number,
    filter?: string
  ) =>
    ['team-members', tenantId, teamId, limit ?? null, filter ?? null] as const,
  memberListByTenant: (tenantId?: UUID) => ['team-members', tenantId] as const,
  roleList: (tenantId?: UUID, teamId?: UUID, limit?: number, filter?: string) =>
    ['team-roles', tenantId, teamId, limit ?? null, filter ?? null] as const,
  roleListByTeam: (tenantId?: UUID, teamId?: UUID) =>
    ['team-roles', tenantId, teamId] as const,
};

export const teamMutationKeys = {
  createTeam: (tenantId?: UUID) => ['createTeam', tenantId] as const,
  updateTeam: (tenantId?: UUID, teamId?: UUID) =>
    ['updateTeam', tenantId, teamId] as const,
  deleteTeam: (tenantId?: UUID) => ['deleteTeam', tenantId] as const,
  addTeamMembers: (tenantId?: UUID, teamId?: UUID) =>
    ['addTeamMembers', tenantId, teamId] as const,
  removeTeamMember: (tenantId?: UUID, teamId?: UUID) =>
    ['removeTeamMember', tenantId, teamId] as const,
  assignTeamRole: (tenantId?: UUID, teamId?: UUID) =>
    ['assignTeamRole', tenantId, teamId] as const,
  removeTeamRole: (tenantId?: UUID, teamId?: UUID) =>
    ['removeTeamRole', tenantId, teamId] as const,
};
